export default {
    UNKNOWN: 'unknown',
    POOR: 'poor',
    FAIR: 'fair',
    GOOD: 'good',
    VERY_GOOD: 'very-good',
    EXCELLENT: 'excellent',
    PREQUALIFIED: 'prequalified',
};
